import { BehaviorSubject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { EcmService } from '../../ecm.service';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import {Router} from '@angular/router';

interface DesignSource {
  id: number;
  sourceName: string;
}

interface Program {
  id: number;
  programNameYear: string;
}

interface Engineer {
  id: number;
  lastFirstName: string;
}

@Component({
  selector: 'ecm-reports',
  templateUrl: './ecm-reports.component.html',
  styleUrls: ['./ecm-reports.component.scss']
})
export class EcmReportsComponent implements OnInit {

  tools: any[];

  _designSourcesEnabled: boolean;
  _programEnabled: boolean;
  _engineerEnabled: boolean;

  _designSources: any[];
  _programSources: any[];
  _engineerSources: any[];

  designSourcesSelected: DesignSource;
  programSelected: Program;
  engineerSelected: Engineer;

  selectedTools: any[] = [];
  resourced = false;

  constructor(
    private readonly router: Router,
    private readonly ecmService: EcmService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    this.ecmService.getDesignSourceCriteria()
      .subscribe((data: any) => this._designSources = data);

    this.ecmService.getProgramCriteria()
      .subscribe((data: any) => this._programSources = data);

    this.ecmService.getEngineerCriteria()
      .subscribe((data: any) => this._engineerSources = data);

      if (this.router.url === '/tprecm/ecm/re-source') {
          this.resourced = true;

      }
  }

  get designSources(): any[] {
    return this.designSourcesEnabled ? this._designSources : [];
  }

  get programSources(): any[] {
    return this.programEnabled ? this._programSources : [];
  }

  get engineerSources(): any[] {
    return this.engineerEnabled ? this._engineerSources : [];
  }

  set designSourcesEnabled(val: boolean) {
    this._designSourcesEnabled = val;
    this.updateTools();
  }

  get designSourcesEnabled(): boolean {
    return this._designSourcesEnabled;
  }

  set programEnabled(val: boolean) {
    this._programEnabled = val;
    this.updateTools();
  }

  get programEnabled(): boolean {
    return this._programEnabled;
  }

  set engineerEnabled(val: boolean) {
    this._engineerEnabled = val;
    this.updateTools();
  }

  get engineerEnabled(): boolean {
    return this._engineerEnabled;
  }

  /*
    This method reloads the tool list based on the selected criteria on ECM reports modal
   */
  async updateTools(): Promise<void> {
    this.tools = this.designSourcesEnabled || this.programEnabled || this.engineerEnabled ?
      await this.ecmService.findToolsByCriteria(
        this.designSourcesEnabled ? (this.designSourcesSelected || { id: null }).id : null,
        this.programEnabled ? (this.programSelected || { id: null }).id : null,
        this.engineerEnabled ? (this.engineerSelected || { id: null }).id : null,
          this.resourced
      ).pipe(first()).toPromise()
      : [];
  }

  printReport(): void {
    if (this.selectedTools.length <= 0) {
      this.toastr.error('Please select at least one tool to print report for.');
      return;
    }

    this.ecmService.printEcmReports(this.selectedTools.map(tool => tool.id));
  }
}
